import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import {initModal} from '../../resources/js/module/modal';

$(document).ready(function () {
    initModal();
    Fancybox.bind("[data-fancybox]", {});
})
